<p-toast></p-toast>

<div class="p-fluid p-formgrid justify-content-center card" style="display: flex; flex-wrap:wrap">
    <div class="field md:col-4 col-12">
        <p-button label="{{ 'UPDATE_JAMABANDI' | translate }}" [raised]="true" (click)="onClickUpdateJamabandi()" severity="info"></p-button>
    </div>
</div>